import React from "react";
import Fade from "react-reveal/Fade";

const PUBLIC_URL = process.env.PUBLIC_URL || "";

function realisationSrc(fileName: string): string {
  const dir = encodeURIComponent("NOS RÉALISATIONS");
  return `${PUBLIC_URL}/${dir}/${encodeURIComponent(fileName)}`;
}

const REALISATION_IMAGES: { src: string; alt: string }[] = [
  {
    src: realisationSrc("ChatGPT Image Mar 19, 2026, 09_47_56 AM 1.png"),
    alt: "Réalisation Kazamansa — panneau décoratif portrait",
  },
  {
    src: realisationSrc("ChatGPT Image Mar 19, 2026, 09_56_11 AM 1.png"),
    alt: "Réalisation Kazamansa — panneau iconographique",
  },
  {
    src: realisationSrc("Smiling portrait of an elderly man (1) 1.png"),
    alt: "Réalisation Kazamansa — portrait souriant sur grand format",
  },
  {
    src: realisationSrc("Smiling portrait of an elderly man (1) 2.png"),
    alt: "Réalisation Kazamansa — portrait sur carrelage",
  },
  {
    src: realisationSrc("Smiling portrait of an elderly man (1) 3.png"),
    alt: "Réalisation Kazamansa — portrait mural",
  },
];

const NosRealisationsSection = () => {
  const trackItems = [...REALISATION_IMAGES, ...REALISATION_IMAGES];

  return (
    <section
      className="section-nos-realisations"
      aria-labelledby="nos-realisations-heading"
    >
      <Fade bottom>
        <h2
          id="nos-realisations-heading"
          className="nos-realisations-title text-center"
        >
          NOS RÉALISATIONS
        </h2>
      </Fade>
      <div className="nos-realisations-marquee" role="region" aria-label="Galerie de réalisations">
        <div className="nos-realisations-marquee-track">
          {trackItems.map((item, index) => (
            <div
              key={`${item.src}-${index}`}
              className="nos-realisations-card"
            >
              <div className="nos-realisations-card-mount">
                <div className="nos-realisations-card-panel">
                  <img
                    src={item.src}
                    alt={item.alt}
                    loading="lazy"
                    className="nos-realisations-card-img"
                    decoding="async"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NosRealisationsSection;
